import { Container, Grid } from "@mui/material";
import React, { useEffect } from "react";
import AOS from 'aos';
import 'aos/dist/aos.css'
import SectionHeading from "../../Components/SectionHeading";

import pcs_p from "../../images/pcs_p.png"
import bscscan from "../../images/bscscan_p.png"
import cmc_p from "../../images/cmc_p.png"
import gc_p from "../../images/gc_p.png"

const Invest = () => {
    useEffect(() =>{
        AOS.init({duration: 2000})
    })
    return(
        <div className="py-5">
            <Container>
                <Grid
                    container
                    justifyContent="center"
                    alignContent="center"
                    className="pt-md-5"
                >
                    <Grid
                        xs={12}
                        data-aos="zoom-in"
                    >
                        <SectionHeading
                            heading = "Metasnooker Is Pioneering The Blockchain Esports Gaming Industry!" 
                            customClass = " mx-auto text-center"
                        />
                    </Grid>
                    <Grid
                        xs={12}
                        className="text-center align-self-center mx-auto"
                    >
                        <a 
                            href="https://pancakeswap.finance/swap?outputCurrency=0xBa8d9B8F138EE5269A5C23339775510D050b75C1" 
                            className="MS---Neon--Button btn mt-4"
                            target="_blank"
                            data-aos="zoom-in"
                        >
                            INVEST IN THE FUTURE
                            {/* <div class="bg"></div> */}
                        </a>
                    </Grid>
                </Grid>
            </Container>
        </div>
    );
}

export default Invest;